import Paper from "@material-ui/core/Paper";
import Header from "../components/mainComponents/Header";
import { codeOfEthics } from "../data";
import React from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  paper: {
    marginBottom: "2rem",
  },
  accord: {
    padding: "2rem 10%",
  },
}));

export default function SimpleAccordion() {
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:1200px)");
  const classes = useStyles(theme);
  const renderAccordion = () => {
    return codeOfEthics.map((item, index) => {
      return (
        <React.Fragment key={index}>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`${item.panel}bh-content`}
              id={`${item.panel}bh-header`}
            >
              <Typography className={classes.heading}>{item.title}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                <b>
                  {item.text.map((ele, index) => {
                    return <React.Fragment key={index}>-{ele}</React.Fragment>;
                  })}
                </b>
              </Typography>
            </AccordionDetails>
          </Accordion>
        </React.Fragment>
      );
    });
  };

  return (
    <div className={classes.root}>
      <Paper
        className={classes.paper}
        style={isMobile ? null : { height: "70vh" }}
      >
        <Header headerText={"code of conduct"} />
        <div className={classes.accord}>{renderAccordion()}</div>
      </Paper>
    </div>
  );
}
